// Types
import type { SelectOptionType } from "types"

export const chequeList: SelectOptionType[] = [
  {
    label: "Yes",
    value: "true"
  },
  {
    label: "No",
    value: "false"
  }
]